module.exports = __webpack_public_path__ + "img/type_onedrive_icon.b70f9ef7.svg";